import React, { useRef } from 'react';
import { TextSearchReplace } from '..';

export type EditableInputProps = {
  value?: string;
  onChange?: (value: string) => void;
  multiline?: boolean;
  label?: string;
  disabled?: boolean;
  error?: string;
  className?: string;
};

export const EditableInput: React.FC<EditableInputProps> = ({
  value = '',
  onChange,
  disabled = false,
  label,
  error,
  className,
}) => {
  const editorRef = useRef<HTMLDivElement>(null);

  return (
    <div className={`flex flex-col gap-2 w-full ${className ?? ''}`}>
      {label && (
        <label className="text-mainText text-small font-normal mb-1">
          {label}
        </label>
      )}
      <div className="relative">
        <TextSearchReplace
          editorRef={editorRef as React.RefObject<HTMLDivElement>}
          initialContent={value}
          onContentChange={onChange}
        />
        {disabled && (
          <div
            className="absolute inset-0 bg-white opacity-50 cursor-not-allowed z-10"
            style={{ pointerEvents: 'all' }}
          />
        )}
      </div>
      {error && (
        <div className="text-danger text-small italic mt-1">
          {error === 'required' ? 'This field is required' : (error ?? '')}
        </div>
      )}
    </div>
  );
};
